// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JoDetail } from './jo-detail';
import { JoHeader } from './jo-header';
import { JoNoteType } from './jo-note-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JoNote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(4) */
  crtnUserInit?: string;
  /** Boolean */
  isIssue!: boolean;
  /** Int32 FK joDetail */
  joDetailId?: number;
  /** Int32 FK joHeader */
  joHeaderId?: number;
  /** String(60) FK joNoteType */
  joNoteTypeId!: string;
  /** DateTimeOffset */
  modTs!: Date;
  /** String(4) */
  modUserInit?: string;
  /** String */
  note?: string;
  /** Binary */
  rowVersion!: any;
  /** FK joDetailId */
  joDetail!: JoDetail;
  /** FK joHeaderId */
  joHeader!: JoHeader;
  /** FK joNoteTypeId */
  joNoteType!: JoNoteType;
}

